<h2 mat-dialog-title class="sk-dialog-title"><mat-icon>groups</mat-icon> Team bearbeiten</h2>

<mat-dialog-content class="dialog-content">
  <p class="sk-muted intro">
    Weise Bauleitern und Vorarbeitern ihre Rolle bei diesem Stammkunden zu.
    Der <strong>Bauleiter</strong> plant Aufträge und Einsätze, der
    <strong>Vorarbeiter</strong> sieht nur seine zugeteilten Aufgaben.
  </p>

  <div class="sk-loading" *ngIf="loadingUsers">
    <mat-spinner diameter="32"></mat-spinner>
  </div>

  <ng-container *ngIf="!loadingUsers">
    <div class="member-row" *ngFor="let row of rows; let i = index">
      <mat-form-field appearance="outline" class="member-user">
        <mat-label>Benutzer</mat-label>
        <mat-select [(ngModel)]="row.userId">
          <mat-option *ngFor="let u of users" [value]="u.id">{{userLabel(u)}}</mat-option>
        </mat-select>
        <mat-icon matPrefix>person</mat-icon>
      </mat-form-field>
      <mat-form-field appearance="outline" class="member-role">
        <mat-label>Rolle</mat-label>
        <mat-select [(ngModel)]="row.role">
          <mat-option value="Bauleiter">Bauleiter</mat-option>
          <mat-option value="Vorarbeiter">Vorarbeiter</mat-option>
        </mat-select>
      </mat-form-field>
      <button mat-icon-button (click)="removeRow(i)" matTooltip="Entfernen">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <div class="add-buttons">
      <button mat-stroked-button (click)="addRow('Bauleiter')">
        <mat-icon>engineering</mat-icon> Bauleiter hinzufügen
      </button>
      <button mat-stroked-button (click)="addRow('Vorarbeiter')">
        <mat-icon>person_add</mat-icon> Vorarbeiter hinzufügen
      </button>
    </div>
  </ng-container>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="cancel()" [disabled]="saving">Abbrechen</button>
  <button mat-raised-button color="primary" (click)="save()" [disabled]="saving || loadingUsers || !valid">
    <mat-icon>save</mat-icon> Team speichern
  </button>
</mat-dialog-actions>
